module.exports = __webpack_public_path__ + "img/notesIcon.0fe9c964.svg";